<template>
  <div class="w3-main main-container">

    <div class="thumbnail-row">
      <div class="header-button-container w3-hide-large">
        <button class="w3-button" @click="showNavbar">☰</button>
      </div>

      <div
        class="thumbnail-container"
        :class="{ active: template._id === activeTemplate._id }"
        v-for="template in templates"
        @click="pickTemplate(template)"
      >
        <div>
          <img
            :src="`static/templates/${template._id}/thumbnail.png`"
          >
        </div>

        <div class="template-name-container">{{ template.name[locale] }}</div>
      </div>
    </div>

    <div class="constructor-container">
      <div class="samples-container">
        <div class="sample">{{ $t('Samples') }}</div>

        <div class="sample-images-container">
          <div
            class="sample-row"
            v-for="sample in activeTemplate.samples"
            @click="pickSample(sample)"
          >
            <img
              :src="`static/templates/${activeTemplate._id}/sample-thumbnails/${sample}`"
            >

            <div>{{ sample.split('.').shift() }}</div>
          </div>
        </div>
      </div>

      <div class="layer-container">
        <img
          :src="`static/templates/${activeTemplate._id}/samples/${pickedSample}`"
        >
        <img
          v-for="layer in activeTemplate.layers"
          :src="`static/templates/${activeTemplate._id}/layers/${layer}`"
        >
      </div>
    </div>

  </div>
</template>

<i18n>
    {
      "de": {
        "Samples": "Mustern",
        "Under development": "Die Webseite ist im Aufbau!"
      },
      "en": {
        "Samples": "Samples"
      },
      "hu": {
        "Samples": "Minták"
      }
    }
  </i18n>

<script>
  import templates from 'static/data/constructor-templates.json';

  require
    .context('static/templates', true, /\.(png|jpg)$/)
    .keys()
    .map(templatePath => templatePath.split('/'))
    .filter(templateElems => templateElems[2])
    .forEach((templateElems) => {
      const name = templateElems[1];
      const property = templateElems[2];
      const img = templateElems[3];
      const template = templates.find(templateElem => templateElem._id === name);

      template[property] = template[property] || [];
      template[property].push(img);
    });

  export default {
    name: 'constructor',
    data() {
      return {
        templates,
        pickedSample: '',
        activeTemplate: {},
      };
    },
    created() {
      document.title = 'Tervező | BeCreative';
    },
    mounted() {
      const { templateId, sample } = this.$route.query;
      const template = this.templates.find(templateElem => templateElem._id === templateId);

      scrollTo(0, 0);

      if (template) {
        if (template.samples.find(elem => elem === sample)) {
          this.pickTemplate(template);
          this.pickSample(sample);
          return;
        }
      }
      this.pickTemplate(this.templates[0]);
      this.pickSample(this.activeTemplate.samples[0]);
    },
    methods: {
      showNavbar() {
        this.$store.commit('setNavbarVisibility', true);
      },
      pickTemplate(template) {
        this.activeTemplate = template;
        this.pickSample(this.activeTemplate.samples[0]);
      },
      pickSample(sampleName) {
        this.pickedSample = sampleName;
        this.setRoute();
      },
      setRoute() {
        this.$router.push({
          path: '/tervezo',
          query: {
            templateId: this.activeTemplate._id,
            sample: this.pickedSample,
          },
        });
      },
    },
    computed: {
      locale() {
        return this.$store.state.i18n.locale;
      },
    },
  };

</script>

<style scoped>
  .main-container {
    overflow-x: hidden;
    min-height: 700px;
  }

  .thumbnail-row {
    text-align: center;
    margin: 0 -40px 0 -40px;
    display: flex;
    justify-content: center;
    height: 125px;
    background-color: #ececec;
  }

  @media (max-width: 500px) {
    .thumbnail-row {
      overflow-x: auto;
      overflow-y: hidden;
    }
  }

  @media (max-width: 992px) {
    .thumbnail-row {
      margin: 0;
    }
  }

  .header-button-container {
    position: absolute;
    left: 0;
  }

  .thumbnail-container {
    margin: 5px;
    border: 1px solid #ececec;
    width: 87px;
    height: 100px;
    text-align: center;
    cursor: pointer;
    line-height: 1;
  }

  .thumbnail-container:hover {
    background: linear-gradient(to bottom, #eaeaea 0, #f7f7f7 43%);
    border: 1px solid #d2d2d2;
    box-shadow: inset 0 0 5px 0 #e9e9e9, 0 1px 5px 0 #dadada;
  }

  .thumbnail-container.active {
    background: linear-gradient(to bottom, #eaeaea 0, #f7f7f7 43%);
    border: 1px solid #d2d2d2;
    box-shadow: inset 0 0 5px 0 #e9e9e9, 0 1px 5px 0 #dadada;
  }

  .thumbnail-container img {
    height: 62px;
    margin: 5px 5px 0 5px;
  }

  .template-name-container {
    font-size: 12px;
  }

  .constructor-container {
    display: flex;
    height: 80%
  }

  .samples-container {
    width: 34%;
    max-width: 600px;
    margin: 5px;
  }

  .sample-images-container {
    overflow: auto;
    box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.175);
    border: 2px solid whitesmoke;
    background-color: whitesmoke;
    height: calc(97vh - 170px);
    max-height: 95%;
    min-height: 275px;
  }

  .sample-row {
    cursor: pointer;
    border: 1px solid lightgrey;
    margin: 6px 2px 6px 2px;
  }

  .sample-row img {
    width: 100%;
  }

  .sample-row div {
    text-align: center;
    font-size: 14px;
  }

  .layer-container {
    position: relative;
    width: 66%
  }

  .layer-container img {
    width: 95%;
    max-width: 65vw;
    position: absolute;
    top: 60px;
    margin: 10px;
    box-shadow: 6px 6px 12px rgba(0, 0, 0, 0.175);
  }

  @media (max-width: 500px) {
    .sample {
      display: none;
    }

    .constructor-container {
      flex-direction: column-reverse;
    }

    .samples-container {
      width: 100%;
      max-width: initial;
      height: calc(100vh - 70vw - 170px);
      margin: 0;
    }

    .layer-container {
      width: 100%;
      height: 62vw
    }

    .layer-container img {
      width: 100%;
      top: -5%;
      max-width: initial;
      margin: 0;
    }
  }
</style>



// WEBPACK FOOTER //
// Constructor.vue?897de248